import { 
  LightBulbIcon, 
  CheckBadgeIcon, 
  ChartBarIcon, 
  UserGroupIcon,
  SparklesIcon,
  RocketLaunchIcon,
  ArrowLongRightIcon
} from '@heroicons/react/24/outline'
import { Helmet } from 'react-helmet-async'
import Navbar from '../Navbar'
import Footer from '../page-main/footer'
import AOS from 'aos';
import 'aos/dist/aos.css';

export default function QuienesSomos() {
  if (typeof window !== 'undefined') {
    AOS.init({
      duration: 1000,
      once: true,
    });
  }

  const organizationSchema = {
    "@context": "https://schema.org",
    "@type": "Organization",
    "name": "Adrox Perú",
    "alternateName": "Adrox",
    "url": "https://adrox.pe",
    "logo": "https://adrox.pe/images/adrox-logo.png",
    "foundingDate": "2020",
    "contactPoint": { "@type": "ContactPoint", "telephone": "+51-933-534-235", "contactType": "sales", "areaServed": ["PE", "BO", "EC"], "availableLanguage": ["Spanish", "English"] },
    "sameAs": ["https://wa.me/+51933534235"],
    "address": { "@type": "PostalAddress", "addressCountry": "PE", "addressLocality": "Lima" },
    "description": "Empresa peruana especializada en desarrollo de software, inteligencia artificial y transformación digital para empresas en América Latina."
  };

  const breadcrumbSchema = {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    "itemListElement": [
      { "@type": "ListItem", "position": 1, "name": "Inicio", "item": "https://adrox.pe" },
      { "@type": "ListItem", "position": 2, "name": "Quiénes Somos", "item": "https://adrox.pe/nosotros" }
    ]
  };

  const localBusinessSchema = {
    "@context": "https://schema.org",
    "@type": "TechnologyCompany",
    "name": "Adrox Perú",
    "image": "https://adrox.pe/images/adrox-logo.png",
    "description": "Empresa líder en desarrollo de software, inteligencia artificial y transformación digital en Perú y América Latina",
    "telephone": "+51933534235",
    "address": { "@type": "PostalAddress", "addressCountry": "PE", "addressLocality": "Lima", "addressRegion": "Lima" },
    "geo": { "@type": "GeoCoordinates", "latitude": "-12.0464", "longitude": "-77.0428" },
    "url": "https://adrox.pe",
    "priceRange": "$$",
    "aggregateRating": { "@type": "AggregateRating", "ratingValue": "4.9", "reviewCount": "100", "bestRating": "5", "worstRating": "1" }
  };

  const webPageSchema = {
    "@context": "https://schema.org", "@type": "AboutPage",
    "name": "Quiénes Somos - Adrox Perú",
    "description": "Conoce la historia, misión, visión y valores de Adrox Perú",
    "url": "https://adrox.pe/nosotros", "inLanguage": "es-PE",
    "isPartOf": { "@type": "WebSite", "name": "Adrox Perú", "url": "https://adrox.pe" },
    "about": { "@type": "Organization", "name": "Adrox Perú" },
    "mainEntity": { "@type": "Organization", "name": "Adrox Perú" }
  };

  const faqSchema = {
    "@context": "https://schema.org", "@type": "FAQPage",
    "mainEntity": [
      { "@type": "Question", "name": "¿Qué servicios ofrece Adrox Perú?", "acceptedAnswer": { "@type": "Answer", "text": "Adrox Perú ofrece desarrollo de software personalizado, soluciones de inteligencia artificial, transformación digital, desarrollo web y móvil, y consultoría tecnológica para empresas en América Latina." } },
      { "@type": "Question", "name": "¿Cuándo fue fundada Adrox?", "acceptedAnswer": { "@type": "Answer", "text": "Adrox fue fundada en 2020 y desde entonces ha completado más de 150 proyectos exitosos para más de 100 clientes satisfechos." } },
      { "@type": "Question", "name": "¿En qué países opera Adrox?", "acceptedAnswer": { "@type": "Answer", "text": "Adrox opera principalmente en Perú y atiende clientes en 3 países de América Latina, incluyendo Bolivia y Ecuador." } },
      { "@type": "Question", "name": "¿Cuál es la misión de Adrox?", "acceptedAnswer": { "@type": "Answer", "text": "Nuestra misión es democratizar la tecnología, empoderando a empresas latinoamericanas con soluciones tecnológicas de clase mundial que simplifican procesos complejos y generan valor real." } }
    ]
  };

  return (
    <>
      <Helmet>
        <title>Quiénes Somos - Adrox Perú | Empresa de Desarrollo de Software e IA</title>
        <meta name="description" content="Somos Adrox Perú, expertos en desarrollo de software e IA. Desde 2020, transformamos empresas con tecnología de vanguardia." />
        <meta name="keywords" content="Adrox Perú, empresa de software, desarrollo de software Perú, inteligencia artificial, transformación digital" />
        <meta name="robots" content="index, follow, max-image-preview:large" />
        <meta name="geo.region" content="PE-LIM" />
        <meta name="geo.placename" content="Lima" />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://www.adrox.top/nosotros" />
        <meta property="og:title" content="Quiénes Somos - Adrox Perú" />
        <meta property="og:description" content="Empresa peruana de tecnología. 150+ proyectos exitosos en América Latina." />
        <meta property="og:image" content="https://adrox.pe/images/adrox-logo.png" />
        <meta property="twitter:card" content="summary_large_image" />
        <meta property="twitter:title" content="Quiénes Somos - Adrox Perú" />
        <meta property="twitter:description" content="Conoce a Adrox Perú, líder en desarrollo de software e IA en América Latina." />
        <meta property="twitter:image" content="https://adrox.pe/images/adrox-logo.png" />
        <link rel="canonical" href="https://www.adrox.top/nosotros" />
        <meta name="theme-color" content="#353E40" />
        <script type="application/ld+json">{JSON.stringify(organizationSchema)}</script>
        <script type="application/ld+json">{JSON.stringify(breadcrumbSchema)}</script>
        <script type="application/ld+json">{JSON.stringify(localBusinessSchema)}</script>
        <script type="application/ld+json">{JSON.stringify(webPageSchema)}</script>
        <script type="application/ld+json">{JSON.stringify(faqSchema)}</script>
      </Helmet>

      <div className="bg-white selection:bg-[#366D73]/20 selection:text-[#353E40]">
        <Navbar />
        
        {/* ============= HERO ============= */}
        <header className="relative pt-20 pb-16 sm:pb-24 overflow-hidden">
          {/* Dot grid */}
          <div
            className="absolute inset-0 -z-10"
            style={{
              backgroundImage: 'radial-gradient(#353E4014 1.5px, transparent 1.5px)',
              backgroundSize: '28px 28px',
            }}
          />
          <div className="absolute inset-0 -z-10 bg-[radial-gradient(ellipse_80%_50%_at_50%_-10%,#07F2F20d,transparent)]" />

          <div className="mx-auto max-w-5xl px-6 lg:px-8 pt-20 text-center">

            <h1
              data-aos="fade-up"
              className="text-4xl sm:text-6xl lg:text-7xl font-bold tracking-tight text-[#353E40] leading-[1.08] text-center"
            >
              Transformamos{' '}
              <span className="text-[#366D73] block sm:mt-2">
                ideas en realidad
              </span>
            </h1>
            
            <p 
              data-aos="fade-up"
              data-aos-delay="150"
              className="mt-6 text-lg sm:text-xl text-gray-500 max-w-2xl mx-auto leading-relaxed"
            >
              Somos Adrox. Una empresa peruana que está redefiniendo el futuro digital 
              de América Latina con tecnología de vanguardia e inteligencia artificial.
            </p>

            <div 
              data-aos="fade-up"
              data-aos-delay="250"
              className="mt-10 flex items-center justify-center gap-4"
            >
              <a
                href="https://wa.me/+51933534235?text=Hola%20estoy%20interesado%20en%20adrox"
                target="_blank"
                rel="noopener noreferrer"
                className="rounded-xl bg-[#366D73] px-8 py-3.5 text-sm font-semibold text-white hover:bg-[#3B8C8C] transition-all duration-200 hover:scale-[1.02] transform-gpu shadow-sm"
                style={{ willChange: 'transform' }}
              >
                Conversemos
              </a>
              <a
                href="#mision"
                className="text-sm font-semibold text-[#353E40] hover:text-[#366D73] transition-colors border-b border-[#353E40]/20 hover:border-[#366D73]"
              >
                Conocer más
              </a>
            </div>
          </div>
        </header>

        {/* ============= STATS ============= */}
        <section className="border-y border-gray-100 py-16">
          <div className="mx-auto max-w-5xl px-6 lg:px-8">
            <div className="grid grid-cols-2 lg:grid-cols-4 gap-6">
              {[
                { value: '2020', label: 'Año de fundación' },
                { value: '150+', label: 'Proyectos completados', accent: true },
                { value: '100+', label: 'Clientes satisfechos' },
                { value: '3', label: 'Países atendidos', accent: true },
              ].map((stat, i) => (
                <div 
                  key={stat.label}
                  className="text-center py-6"
                  data-aos="fade-up"
                  data-aos-delay={i * 80}
                >
                  <div className={`text-4xl sm:text-5xl font-bold tracking-tight ${stat.accent ? 'text-[#366D73]' : 'text-[#353E40]'}`}>
                    {stat.value}
                  </div>
                  <div className="text-sm text-gray-500 mt-2 font-medium">
                    {stat.label}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* ============= MISIÓN ============= */}
        <section className="py-20 sm:py-28" id="mision">
          <div className="mx-auto max-w-5xl px-6 lg:px-8">
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
              <div data-aos="fade-right">
                <p className="text-xs font-semibold text-[#366D73] tracking-[0.2em] uppercase mb-4">
                  Nuestra Misión
                </p>
                <h2 className="text-4xl sm:text-5xl font-bold tracking-tight text-[#353E40] leading-[1.1]">
                  Democratizar <br/>
                  <span className="text-[#366D73]">la tecnología</span>
                </h2>
                <div className="mt-8 space-y-4 text-gray-500 leading-relaxed">
                  <p>
                    Empoderamos a empresas latinoamericanas con soluciones tecnológicas de clase mundial. 
                    Hacemos que la innovación sea accesible, simple y efectiva para organizaciones de todos los tamaños.
                  </p>
                  <p>
                    Creemos que cada negocio merece tener acceso a herramientas que antes solo estaban 
                    disponibles para grandes corporaciones.
                  </p>
                </div>
              </div>
              <div 
                className="relative h-72 lg:h-96 rounded-2xl overflow-hidden bg-[#353E40]"
                data-aos="fade-left"
              >
                <img 
                  src="https://images.unsplash.com/photo-1522071820081-009f0129c71c?w=800&h=600&fit=crop" 
                  alt="Equipo de desarrollo de software de Adrox Perú" 
                  className="absolute inset-0 w-full h-full object-cover opacity-80"
                  loading="lazy"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-[#353E40]/40 to-transparent"></div>
                <div className="absolute bottom-6 left-6 flex items-center gap-3 text-white">
                  <RocketLaunchIcon className="h-5 w-5 text-[#07F2F2]" />
                  <span className="text-sm font-medium">Tecnología sin límites</span>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* ============= VISIÓN ============= */}
        <section className="py-20 sm:py-28 bg-[#353E40]">
          <div className="mx-auto max-w-5xl px-6 lg:px-8">
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
              <div 
                className="relative h-72 lg:h-96 rounded-2xl overflow-hidden"
                data-aos="fade-right"
              >
                <img 
                  src="https://images.unsplash.com/photo-1504384308090-c894fdcc538d?w=800&h=600&fit=crop" 
                  alt="Desarrollador trabajando en soluciones de IA en Adrox" 
                  className="absolute inset-0 w-full h-full object-cover opacity-80"
                  loading="lazy"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-[#353E40]/60 to-transparent"></div>
                <div className="absolute bottom-6 left-6 flex items-center gap-3 text-white">
                  <SparklesIcon className="h-5 w-5 text-[#07F2F2]" />
                  <span className="text-sm font-medium">Liderando el futuro</span>
                </div>
              </div>
              <div data-aos="fade-left">
                <p className="text-xs font-semibold text-[#07F2F2] tracking-[0.2em] uppercase mb-4">
                  Nuestra Visión
                </p>
                <h2 className="text-4xl sm:text-5xl font-bold tracking-tight text-white leading-[1.1]">
                  Ser el futuro de <br/>
                  <span className="text-[#07F2F2]">América Latina</span>
                </h2>
                <div className="mt-8 space-y-4 text-gray-300 leading-relaxed">
                  <p>
                    Aspiramos a ser la empresa líder en transformación digital de la región, reconocida 
                    por nuestra excelencia técnica y el impacto positivo que generamos.
                  </p>
                  <p>
                    Queremos ser el socio tecnológico de confianza que impulsa el crecimiento y 
                    la competitividad de las empresas en la era digital.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* ============= VALORES ============= */}
        <section className="py-20 sm:py-28">
          <div className="mx-auto max-w-5xl px-6 lg:px-8">
            <div className="text-center max-w-2xl mx-auto mb-16" data-aos="fade-up">
              <p className="text-xs font-semibold text-[#366D73] tracking-[0.2em] uppercase mb-4">
                Nuestros principios
              </p>
              <h2 className="text-4xl sm:text-5xl font-bold tracking-tight text-[#353E40] leading-[1.1]">
                Lo que nos <span className="text-[#366D73]">define</span>
              </h2>
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
              {[
                { icon: LightBulbIcon, title: 'Innovación Constante', desc: 'La innovación está en nuestro ADN. Desarrollamos soluciones tecnológicas de vanguardia que transforman la manera en que las empresas operan y crecen.' },
                { icon: CheckBadgeIcon, title: 'Excelencia en el Servicio', desc: 'Entregamos calidad excepcional en cada proyecto. Nuestro equipo trabaja incansablemente para superar expectativas.' },
                { icon: ChartBarIcon, title: 'Resultados Medibles', desc: 'Nos enfocamos en generar impacto real y tangible. Cada solución está diseñada para optimizar procesos y aumentar la eficiencia.' },
                { icon: UserGroupIcon, title: 'Equipo Comprometido', desc: 'Contamos con profesionales altamente capacitados que combinan experiencia técnica con pasión por la tecnología.' }
              ].map((val, i) => (
                <div key={val.title} className="group border border-gray-100 rounded-2xl p-6 sm:p-8 hover:border-[#366D73]/30 transition-all duration-300"
                  data-aos="fade-up" data-aos-delay={i * 80}>
                  <div className="w-10 h-10 rounded-full bg-[#366D73]/10 flex items-center justify-center mb-5 group-hover:bg-[#366D73]/20 transition-colors">
                    <val.icon className="h-5 w-5 text-[#366D73]" />
                  </div>
                  <h3 className="text-lg font-bold text-[#353E40] mb-2">{val.title}</h3>
                  <p className="text-sm text-gray-500 leading-relaxed">{val.desc}</p>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* ============= CTA ============= */}
        <section className="py-20 sm:py-28 bg-[#353E40]">
          <div className="mx-auto max-w-3xl px-6 lg:px-8 text-center">
            <div data-aos="fade-up">
              <h2 className="text-3xl sm:text-4xl font-bold tracking-tight text-white">
                ¿Listo para <span className="text-[#07F2F2]">innovar</span>?
              </h2>
              <p className="mt-4 text-gray-300 text-lg max-w-xl mx-auto">
                Conversemos sobre cómo podemos llevar tu negocio al siguiente nivel 
                con tecnología de vanguardia.
              </p>
              <div className="mt-8">
                <a
                  href="https://wa.me/+51933534235?text=Hola%20estoy%20interesado%20en%20adrox"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center gap-2 rounded-xl bg-white px-8 py-3.5 text-sm font-semibold text-[#353E40] hover:bg-gray-100 transition-all duration-200 hover:scale-[1.02] transform-gpu"
                  style={{ willChange: 'transform' }}
                >
                  Contáctanos <ArrowLongRightIcon className="h-4 w-4" />
                </a>
              </div>
            </div>
          </div>
        </section>

        <Footer />
      </div>
    </>
  )
}